import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { FunctionComponent, useState } from 'react';
import { X } from 'react-feather';
import { useSelector } from 'react-redux';
import { authenticatedRequest } from '../../../../../api';
import { RootState } from '../../../../../store/reducers/rootReducers';
import { invite_director } from '../../../../../apis/business-accounts';
interface InviteDirectorModalProps {
    showModal: boolean;
    hideModal: (val: boolean) => void;
    inviteDirectorData?: any;
    activeData?: any;
    setDirectors: (val: any[]) => void;
    directors: any[];
    businessType: string;
}

const InviteDirectorModal: FunctionComponent<InviteDirectorModalProps> = ({
    showModal,
    hideModal,
    inviteDirectorData,
    activeData,
    directors,
    setDirectors,
    businessType,
}: InviteDirectorModalProps) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const auth: any = useSelector((state: RootState) => state.auth);

    const onFinish = (values: any) => {
        const submitObj = {
            businessName: activeData?.businessName,
            firstName: values.firstName,
            email: values.email,
            documentLabel: inviteDirectorData?.name,
            userName: auth?.user.firstName + ' ' + auth?.user?.lastName,
        };
        setLoading(true);
        authenticatedRequest()
            .post(invite_director, submitObj)
            .then((res) => res.data)
            .then((res) => {
                setLoading(false);
                const index = inviteDirectorData?.index;
                const tempArr = [...directors];
                tempArr[index] = {
                    ...tempArr[index],
                    inviteId: res?.id,
                    email: values.email,
                    firstName: values.firstName,
                };
                setDirectors([...tempArr]);
                notification.success({
                    message: 'Success',
                    description: 'An invitation to upload their personal details has been sent to ' + values.firstName,
                });
                hideModal(false);
            })
            .catch((err) => {
                setLoading(false);
                const resp = err?.response;
                notification.error({
                    message: 'Error',
                    description: resp?.data?.message || 'Oops! An unexpected error occurred.',
                });
            });
    };
    return (
        <Modal
            title={`Invite ${
                businessType == 'Company' ? 'Director' : businessType == 'Partnership' ? 'Partner' : 'Person'
            }`}
            visible={showModal}
            onCancel={() => hideModal(false)}
            footer={false}
            getContainer={false}
            closeIcon={<X className="close-modal" />}
            width="40%"
            className="pickup-wrapper"
        >
            <Form form={form} onFinish={onFinish}>
                <div className="info" style={{ marginBottom: '15px' }}>
                    Please enter the details of directors you would like to invite
                </div>
                <Row gutter={20}>
                    <Col span={12}>
                        <Form.Item
                            label="Enter email"
                            name="email"
                            className="label"
                            rules={[{ required: true, message: 'Please enter email!', type: 'email' }]}
                        >
                            <Input className="gapstack-input" placeholder="john@gapstack.com" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="First Name"
                            name="firstName"
                            className="label"
                            initialValue={inviteDirectorData?.name?.split(' ')[0]}
                        >
                            <Input className="gapstack-input" placeholder="John" />
                        </Form.Item>
                    </Col>
                </Row>
                <div className="button-wrapper">
                    <Button className="cancel-button" onClick={() => hideModal(false)}>
                        Cancel
                    </Button>
                    <Button className="terms-and-conditions-button" htmlType="submit" loading={loading}>
                        Send Invite
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};

export default InviteDirectorModal;
